import React, { ReactNode } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { ArrowForward } from "@mui/icons-material";
interface CustomPaperProps {
    title: string;
    isLoading:boolean;
}
const ButtonLoader = ({ title,isLoading=false }: CustomPaperProps) => {
    return (
        <>
        {isLoading ? (
            <CircularProgress
              size={24}
              color="inherit"
              sx={{
                position: "absolute", // Center spinner in button
              }}
            />
          ) : (
            <>
              {title}
            </>
          )
        }
    </>
    );
};

export default ButtonLoader;
        